import ProgressBarRenderDefault from "./ProgressBarRenderDefault";
// import {useEffect, useState} from "react";

const ProgressBarComponent = (props: any) => {
  const { item, Render = ProgressBarRenderDefault } = props;
  // const [data, setData] = useState<any>();
  //
  // //TODO delete this effect before live
  // useEffect(() => {
  // 	const fakeData = {
  // 		LiveEntries: 1500,
  // 		TicketsSoldPercent: 3.5,
  // 		FormattedTicketsSold: "42",
  // 		FormattedMaxTickets: "1,200",
  // 		FormattedTicketsLeft: "115,158",
  // 		FormattedTicketsSoldPercent: "3.5%"
  // 	}
  // 	setData({...item, ...fakeData});
  // }, []);
  // //TODO -------end of delete zone

  // return <Render data={data} />;
  return <Render data={item} />;
};

export default ProgressBarComponent;
